import { FilterOptionSelectedValueModel } from '../view-models/FamilyOptionModel';
import BaseSearchService from './BaseSearchService';

export default class ProductsSearchService extends BaseSearchService {

    public searchProductsByFamily(familyId: number | null, categoryId: number | null, pageIndex: number, languageId: string,
        filters: { [name: string]: FilterOptionSelectedValueModel } | null,
        orderBy: any[],
        pathAndQueryString: string,
        retrieveFamilyOptions: boolean): Promise<any> {

        return this.axios
            .post(`/api/products/search?languageId=${languageId}`, {
                pageIndex: pageIndex,
                languageId: languageId,
                categoryId: categoryId,
                familyId: familyId,
                filters: filters,
                orderBy: orderBy,
                pathAndQueryString: pathAndQueryString,
                retrieveFamilyOptions: retrieveFamilyOptions
            })
            .then((res) => {
                return res.data;
            });
    }

    public searchProductsFull(term: string, pageIndex: number, languageId: string,
        filters: { [name: string]: FilterOptionSelectedValueModel } | null,
        orderBy: any[],
        pathAndQueryString: string,
        retrieveFamilyOptions: boolean): Promise<any> {

        return this.axios
            .post(`/api/products/search-full?languageId=${languageId}`, {
                pageIndex: pageIndex,
                languageId: languageId,
                searchTerm: term,
                filters: filters,
                orderBy: orderBy,
                pathAndQueryString: pathAndQueryString,
                retrieveFamilyOptions: retrieveFamilyOptions
            },
                { withCredentials: !this.isDev })
            .then((res) => {
                return res.data;
            });
    }

    public pushSearchHistory(familyId: number, pathAndQueryString: string, languageId: string) {
        return this.axios
            .post(`/api/products/last-search-endpoint/${familyId}?languageId=${languageId}`, {
                pathAndQueryString: pathAndQueryString
            },
                { withCredentials: !this.isDev })
            .then((res) => {
                return res.data;
            });
    }

    public pushFullSearchHistory(pathAndQueryString: string, languageId: string) {
        return this.axios
            .post(`/api/products/last-search-full-endpoint?languageId=${languageId}`, {
                pathAndQueryString: pathAndQueryString
            },
                { withCredentials: !this.isDev })
            .then((res) => {
                return res.data;
            });
    }
}